import React from 'react';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import './AnonymousContentPanelStyles.scss';

const AnonymousContentPanel = ({ children, style }) => (
  <Paper className="anonymous-panel" style={{ padding: 16, ...style }} elevation={10}>
    {children}
  </Paper>
);

AnonymousContentPanel.propTypes = {
  children: PropTypes.node.isRequired,
  style: PropTypes.object,
};

export default AnonymousContentPanel;



// WEBPACK FOOTER //
// ./src/components/budgetAuth/AnonymousContentPanel.js